module.exports = __webpack_public_path__ + "img/28.e163ecbc.png";